import $ from 'jquery';

export default function languageBar() {
  const bar = $('.block--language-bar');
  const icon = bar.find('.block__icon');
  const exit = bar.find('.block__exit');
  const languages = bar.find('.block__languages');

  if (bar.find('.block__toggle') || bar.find('.block__arrow')) {
    $(document).on('click', '.block__toggle, .block__arrow', () => {
      bar.toggleClass('toggle-is-open');
      $(languages).slideToggle();
    });

    icon.on('click', () => {
      bar.addClass('is-active');
    });

    exit.on('click', () => {
      bar.removeClass('default-active');
      bar.addClass('on-exit');

      setTimeout(() => bar.removeClass('on-exit'), 250);

      bar.removeClass('is-active');
      bar.removeClass('toggle-is-open');
      $(languages).slideUp();
    });
  }
};
